import React, { useEffect } from 'react';
import { useHistory, useLocation, Route } from 'react-router-dom';
import { URL } from '../../constant';
import OcrHistory from './history/OcrHistory';
import OcrUsage from './OcrUsage';
import Recommend from './rcmndLearning/Recommend';

function OCR() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const { state } = location;
    if (state?.detail) {
      
      const {
        page,
        data = null,
        fulls3path = null,
        latex = '',
        average = null,
      } = state.detail;

      if (process.env.REACT_APP_ENV === 'development') {
        console.log(state);
      }

      if (page === URL.SELECT_LEARNING) {
        history.push(page)
      } else {
        history.push({
          pathname: `${URL.OCR.I}${page}`,
          state: {
            data,
            latex,
            average,
            fulls3path
          }
        })

      }
    }
  }, [location])

  return (
    <React.Fragment>
      <Route path={ URL.OCR.HISTORY }><OcrHistory /></Route>
      <Route path={ URL.OCR.USAGE }><OcrUsage /></Route>
      <Route path={ URL.OCR.RECOMMEND_LEARNING }><Recommend /></Route>
    </React.Fragment>
  );
}

export default OCR;